import { render, staticRenderFns } from "./SelectionChangeWarning.vue?vue&type=template&id=4dd3078c"
import script from "./SelectionChangeWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectionChangeWarning.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports